import PropTypes from 'prop-types';
import { usePermissions, useTranslate } from 'react-admin';
import { RightDrawer } from '@/components/global/drawers/RightDrawer.jsx';
import { DeviceConfigContent } from '@/components/device/config/DeviceConfigContent.jsx';
import { canViewDeviceConfig, getDeviceConfigDrawerDeviceId } from '@/helpers/device/deviceConfig.js';

export const DeviceConfigShow = ({ handleClose, elementId }) => {
    const { isLoading, permissions } = usePermissions();
    const translate = useTranslate();

    if (isLoading || !canViewDeviceConfig(permissions) || !elementId) {
        return null;
    }

    return (
        <RightDrawer handleClose={handleClose} title={translate('resources.device.labels.deviceConfiguration')}>
            <DeviceConfigContent deviceId={getDeviceConfigDrawerDeviceId(elementId)} />
        </RightDrawer>
    );
};

DeviceConfigShow.propTypes = {
    handleClose: PropTypes.func.isRequired,
    elementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
